import {} from '../mutation-types'

var _question = [{
  'suggest_id': '9',
  'title': '购票问题',
  'question_list': [{
    'title': 'Q1: 去哪里买票？',
    'content': [
      '1.下载嘟嘟巴士APP或关注嘟嘟巴士微信公众号使用购票'
    ]
  }, {
    'title': 'Q2: 没有我的线路怎么办？',
    'content': [
      '1.下载嘟嘟巴士后如果发现没有线路，可以使用<span class="custom_make">【定制开通】</span>功能',
      '2.嘟嘟巴士每周都会有新增线路，请关注我们的微信公众号或下载嘟嘟巴士'
    ]
  }, {
    'title': 'Q3: 单次票和乘车卡的区别是什么？',
    'content': [
      '1.单次票：适用于临时或不规律乘车，可单次购买',
      '2.乘车卡：车卡可在一定时间范围内多次乘车使用'
    ]
  }, {
    'title': 'Q4: 买票后不坐车能退票吗？',
    'content': [
      '1.在始发站发车前可退票，请前往<span class="travel_order">【出行订单】</span>-订单详情-退票”进行退票，如果仍有疑问可致电<a class="custom_server" href="tel:4008-520-084">【客服】</a>操作退票事宜'
    ]
  }]
}, {
  'suggest_id': '10',
  'title': '乘车问题',
  'question_list': [{
    'title': 'Q1: 买票后去哪里乘车？',
    'content': [
      '1.在APP中买票后点击班次详情的具体站点，弹出实景地图照片显示上车点，第一次坐车的小伙伴买票后务必加入微信群或联系线路负责人，确认好上车地点，以免错过班车'
    ]
  }, {
    'title': 'Q2: 如何知道现在车在哪儿？',
    'content': [
      '1.嘟嘟巴士每台巴士车上都有导航系统，在APP班次详情中点击车辆位置可以实时定位车辆位置'
    ]
  }, {
    'title': 'Q3: 如果错过了上车时间，巴士车会等我吗？',
    'content': [
      '1.工作生活中难免会遇到迟到上车的情况，这种时候只要在微信群里提前告知队长，巴士车都会酌情等候2分钟。为了大多数乘客的乘车体验，嘟嘟巴士建议您准时到达上车点候车'
    ]
  }, {
    'title': 'Q4: 嘟嘟巴士除了上下班接送外还有别的巴士服务吗？',
    'content': [
      '1.除了上下班接送班车外，嘟嘟巴士还提供专业的巴士包车、城际直通车、周边游定制巴士服务，这些功能服务都能在嘟嘟巴士中找到'
    ]
  }]
}, {
  'suggest_id': '11',
  'title': '安全保障问题',
  'question_list': [{
    'title': 'Q1: 乘坐嘟嘟巴士安全吗，巴士司机靠谱吗？',
    'content': [
      '1.嘟嘟巴士严格筛选巴士与司机，务必保证每辆巴士车都是经验丰富的老师傅驾驶，车辆安全，证件齐全，并且为每个乘客提供100万元保额的座位险'
    ]
  }, {
    'title': 'Q2: 嘟嘟巴士的行驶路线是怎么定的？',
    'content': [
      '1.APP中可查看巴士车行驶路线和停靠站点，嘟嘟巴士拒绝沿路揽客，一人一座专车直达目的地，避开交通拥堵和不必要的绕路'
    ]
  }, {
    'title': 'Q3: 如何知道现在车在哪儿？',
    'content': [
      '1.嘟嘟巴士每台巴士车上都有导航系统，在APP班次详情中点击车辆位置可以实时定位车辆位置，可以实时给家人朋友分享自己所在位置'
    ]
  }, {
    'title': 'Q4: 巴士准时吗？乘车的时候会不会坐过站？',
    'content': [
      '1.嘟嘟巴士的每趟班车都会按时定点在乘车点停靠，不用担心坐过站，每条线路上都有车队队长负责报站名提醒上下车'
    ]
  }]
}, {
  'suggest_id': '12',
  'title': '优惠券问题',
  'question_list': [{
    'title': 'Q1: 怎么得到更多乘车优惠券？',
    'sign': ['优惠码'],
    'content': [
      '1.邀请好友可得10元乘车优惠券，多邀多得，不设上限。嘟嘟巴士官方也会做活动，积极参加官方活动，输入<span class="coupon">【优惠码】</span>即可兑换'
    ]
  }, {
    'title': 'Q2: 邀请好友能得多少优惠券？',
    'content': [
      '1.邀请好友后，被邀请者7天内注册成功并购票，邀请者将得到10元优惠券，多邀多得，不设上限'
    ]
  }, {
    'title': 'Q3: 优惠券为什么不能使用？',
    'content': [
      '1.请核对使用时间：优惠券上注明的起止日期为购票付款使用日期',
      '2.请核对金额：查看付款金额是否满足“满就减”、“上下班券”的条件',
      '3.请核对票务：对应的优惠券只能购买对应的车票'
    ]
  }]
}, {
  'suggest_id': '13',
  'title': '其他问题',
  'question_list': [{
    'title': 'Q1: 第一次乘车需要帮助？',
    'content': [
      '1.第一次乘车如需帮助请直接联系线路负责人或添加客服微信，客服将第一时间为您处理问题'
    ]
  }, {
    'title': 'Q2: 购票成功后会有什么提示？',
    'content': [
      '1.购票成功后5分钟内会收到短信通知'
    ]
  }, {
    'title': 'Q3: 嘟嘟巴士何时开通更多线路，进驻更多城市？',
    'content': [
      '1.嘟嘟巴士每周都会新增更多线路，请关注微信公众号查看每周详细新增路线'
    ]
  }]
}]

const state = {
  questions: _question
}

const mutations = {}
const actions = {}
export default {
  namespaced: true,
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/questions.js